import api from '../../../../libs/api';
import { gridHelper } from '../../../../libs/grid';
import { FieldMapping } from '../../../../libs/grid/gridHelper';
import { useAppSelector } from '../../../core/store';
import * as settings from '../../hooks/useSettings';
import moment from 'moment';
import { State } from '@progress/kendo-data-query';
import configQueryReactSimpleRequest from '../../config/configQuery';
import { useGridV2, useServerGridDataHandler } from '../../../../Hooks/useKendoGrid';

const fieldMapping: FieldMapping[] = [
    { frontFieldName: 'startDate', backFieldName: 'RelaticsDocumentsSyncLog.StartDate' },
    { frontFieldName: 'endDate', backFieldName: 'RelaticsDocumentsSyncLog.EndDate' },
    { frontFieldName: 'status', backFieldName: 'RelaticsDocumentsSyncLog.Status' },
    { frontFieldName: 'message', backFieldName: 'RelaticsDocumentsSyncLog.Message' },
    { frontFieldName: 'emailSend', backFieldName: 'RelaticsDocumentsSyncLog.EmailSend' },
    { frontFieldName: 'errorValidation', backFieldName: 'RelaticsDocumentsSyncLog.errorValidation' },
    { frontFieldName: 'fileNameImport', backFieldName: 'RelaticsDocumentsSyncLog.fileNameImport' },
    { frontFieldName: 'relaticsConfigurationFolderFullPath', backFieldName: 'RelaticsConfigurationFolders.RelaticsConfigurationFolderFullPath' },
];

const fetchRelaticsSyncLogs = (gridState: any, startDateValue: Date | null, endDateValue: Date | null) =>
    api.post('/api/v2/AsiteRelaticsSync/GetRelaticsSyncLogs', {
        safe: true,
        params: { startDate: startDateValue, endDate: endDateValue },
        data: gridHelper.getRequestPayloadFromQueryState(gridState, fieldMapping),
    });

const useRelaticsSyncLogsGrid = (gridState: State, setGridState: React.Dispatch<React.SetStateAction<State>>) => {
    const startDate = useAppSelector(settings.selectors.getStartDate);
    const endDate = useAppSelector(settings.selectors.getEndDate);
  

    const { gridResult, gridQuery } = useGridV2({
        query: {
            queryKey: [
                'get-relatics-logs',
                startDate !== undefined ? moment(startDate).format() : '',
                endDate !== undefined ? moment(endDate).format() : '',
            ],
            queryFn: fetchRelaticsSyncLogs,
            queryOptions: configQueryReactSimpleRequest,
        },
        transform: (item: any) => ({
            ...item,
            startDate: new Date(item.startDate),
            endDate: item.endDate ? new Date(item.endDate) : '',
        }),
        gridState,
        setGridState
    });


    const handleDataStateChange = useServerGridDataHandler({ gridState, setGridState, gridQuery });

    return { RelaticsSyncLogsQuery: gridQuery, gridState, gridResult, handleDataStateChange };
};

export default useRelaticsSyncLogsGrid;
